import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

interface AddOnFilter {
  id: string;
  name: string;
  type: string;
  values: AddOnFilterValue[];
  opened: boolean;
}

interface AddOnFilterValue {
  value: string;
  id?: number;
  checked: boolean;
}

@Component({
  selector: 'app-accessories-filters',
  templateUrl: './accessories-filters.component.html',
  styleUrls: ['./accessories-filters.component.scss']
})
export class AccessoriesFiltersComponent implements OnChanges {
  @Input() currentFragment = 'wheel-accessories';
  @Input() filters: { [id: string]: AddOnFilterValue[] } = {};
  @Input() selectedFilters: { [id: string]: string } = {};
  @Input() showFilters = false;

  @Output() onFilter: EventEmitter<any> = new EventEmitter();

  addOnfilters = {
    'wheel-accessories': [
      {
        id: 'suppliers',
        name: 'SUPPLIERS',
        type: 'checkbox',
        values: [],
        opened: false
      },
    ],
    'lug-nuts': [
      {
        id: 'thread_size',
        name: 'THREAD SIZE',
        type: 'checkbox',
        values: [],
        opened: false
      },
      {
        id: 'color',
        name: 'COLOR',
        type: 'checkbox',
        values: [],
        opened: false
      },
      {
        id: 'lug_net_length',
        name: 'LUG NET LENGTH',
        type: 'checkbox',
        values: [],
        opened: false
      },
      {
        id: 'lug_net_diameter',
        name: 'LUG NET DIAMETER',
        type: 'radio',
        values: [],
        opened: false
      },
      {
        id: 'suppliers',
        name: 'SUPPLIERS',
        type: 'checkbox',
        values: [],
        opened: false
      },
    ],
    'lug-bolts' :[
      {
        id: 'thread_size',
        name: 'THREAD SIZE',
        type: 'checkbox',
        values: [],
        opened: false
      },
      {
        id: 'color',
        name: 'COLOR',
        type: 'checkbox',
        values: [],
        opened: false
      },
      {
        id: 'thread_length',
        name: 'THREAD LENGTH',
        type: 'checkbox',
        values: [],
        opened: false
      },
      {
        id: 'lug_bolt_diameter',
        name: 'LUG BOLT DIAMETER',
        type: 'checkbox',
        values: [],
        opened: false
      },
      {
        id: 'suppliers',
        name: 'SUPPLIERS',
        type: 'checkbox',
        values: [],
        opened: false
      },
    ],
    'hub-rings' :[
      {
        id: 'ext_center_bore',
        name: 'EXT CENTER BORE',
        type: 'checkbox',
        values: [],
        opened: false
      },
      {
        id: 'center_bore',
        name: 'CENTER BORE',
        type: 'checkbox',
        values: [],
        opened: false
      },
      {
        id: 'suppliers',
        name: 'SUPPLIERS',
        type: 'checkbox',
        values: [],
        opened: false
      },
    ],
    'spacers' :[
      {
        id: 'bolt_pattern',
        name: 'BOLT PATTERN',
        type: 'checkbox',
        values: [],
        opened: false
      },
      {
        id: 'width',
        name: 'WIDTH',
        type: 'checkbox',
        values: [],
        opened: false
      },
      {
        id: 'thread_size',
        name: 'THREAD SIZE',
        type: 'checkbox',
        values: [],
        opened: false
      },
      {
        id: 'center_bore',
        name: 'CENTER BORE',
        type: 'checkbox',
        values: [],
        opened: false
      },
      {
        id: 'suppliers',
        name: 'SUPPLIERS',
        type: 'checkbox',
        values: [],
        opened: false
      },
    ],
    'tpms' :[
      {
        id: 'suppliers',
        name: 'SUPPLIERS',
        type: 'checkbox',
        values: [],
        opened: false
      },
    ],
  };

  get currentFilters(): AddOnFilter[] {
    return this.addOnfilters[this.currentFragment];
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateFilters();
  }

  clearAll(): void {
    this.clearFilterValues();
    this.emitFilterEvent({ selectedFilters: {}, clear: true, allValues: this.getFilterIds() });
  }

  hideMblFilters(): void {
    this.showFilters = false;
  }

  onOpenFilter(index: number): void {
    this.currentFilters.forEach(filter => filter.opened = false);
    this.currentFilters[index].opened = !this.currentFilters[index].opened;
  }

  onAddOnFilter($event: any, filterIndex: number, fieldIndex: number): void {
    const field = this.currentFilters[filterIndex].values[fieldIndex];
    field.checked = $event.target.checked;
    this.emitFilterEvent({ selectedFilters: this.getSelectedFilters(), allValues: this.getFilterIds() });
  }

  private updateFilters(): void {
    this.currentFilters.forEach(addOnFilter => {
      const values = this.filters[addOnFilter.id];
      if (values && Array.isArray(values)) {
        addOnFilter.values = values
          .filter(item => item.value !== '')
          .map(item => ({ ...item, checked: this.isValueChecked(addOnFilter.id, (item.id || item.value).toString()) }));
      }
    });
  }

  private clearFilterValues(): void {
    this.currentFilters.forEach(item => item.values.forEach(value => value.checked = false));
  }

  private emitFilterEvent(data: any): void {
    this.onFilter.emit(data);
  }

  private getSelectedFilters(): { [id: string]: string } {
    const selectedFilters = {};
    this.currentFilters.forEach(item => {
      const selectedValues = item.values.filter(value => value.checked).map(value => (value.id || value.value));
      selectedFilters[item.id] = selectedValues.join(',');
    });
    return selectedFilters;
  }

  private getFilterIds(): string[] {
    return this.currentFilters.map(e => e.id);
  }

  private isValueChecked(filterId: string, value: string): boolean {
    return this.selectedFilters[filterId]?.split(',').includes(value) || false;
  }
}
